import { useGetBriefs } from "@entities/brief/lib/hooks/useGetBriefs";
import { BriefClosureStatus } from "@shared/lib/types/brief";
import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";

type UseClosuresBriefsListParams = {
  userIdParam: string;
  selectedPocUserId?: string;
  isQueryEnabled: boolean;
};

export function useClosuresBriefsList({
  userIdParam,
  selectedPocUserId,
  isQueryEnabled,
}: UseClosuresBriefsListParams) {
  const [closureStatus, setClosureStatus] = useState<BriefClosureStatus>(
    BriefClosureStatus.Open
  );
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery] = useDebounce(searchQuery, 1000);

  const activeUserId = (selectedPocUserId ?? userIdParam) || "";

  const { briefs, isFetching, totaldata } = useGetBriefs(
    {
      pageNo,
      limit: pageSize,
      searchQuery: debouncedSearchQuery,
      myPricingTracker: {
        userId: activeUserId,
        closureStatus,
      },
    },
    isQueryEnabled && Boolean(userIdParam)
  );

  useEffect(() => {
    setPageNo(1);
  }, [closureStatus, debouncedSearchQuery, activeUserId]);

  const handlePaginationChange = (page: number, size: number) => {
    setPageNo(page);
    setPageSize(size);
  };

  return {
    closureStatus,
    setClosureStatus,
    pageNo,
    pageSize,
    searchQuery,
    setSearchQuery,
    debouncedSearchQuery,
    briefs,
    isFetching,
    totaldata,
    handlePaginationChange,
  };
}
